
import { Link } from 'react-router-dom';

const articles = [
  {
    id: 'ticaret-hukukunda-yeni-duzenlemeler',
    title: 'Ticaret Hukukunda Yeni Düzenlemeler',
    date: '15 Ocak 2024',
    excerpt: 'Ticaret hukukunda yapılan son düzenlemeler ve şirketler üzerindeki etkileri hakkında detaylı bilgiler.',
    category: 'Ticaret Hukuku',
    image: 'https://public.readdy.ai/ai/img_res/52e55bf572011fc1a0a575d1a293f6bd.jpg',
    slug: 'ticaret-hukukunda-yeni-duzenlemeler'
  },
  {
    id: 'gayrimenkul-alim-satiminda-dikkat-edilmesi-gerekenler',
    title: 'Gayrimenkul Alım Satımında Dikkat Edilmesi Gerekenler',
    date: '10 Ocak 2024',
    excerpt: 'Gayrimenkul alım satım işlemlerinde hukuki süreçler ve dikkat edilmesi gereken önemli noktalar.',
    category: 'Gayrimenkul Hukuku',
    image: 'https://readdy.ai/api/search-image?query=Modern%20real%20estate%20contract%20signing%20scene%20with%20professional%20documents%2C%20house%20keys%2C%20elegant%20office%20environment%2C%20clean%20business%20atmosphere%2C%20sophisticated%20legal%20setting&width=400&height=250&seq=article2&orientation=landscape',
    slug: 'gayrimenkul-alim-satiminda-dikkat-edilmesi-gerekenler'
  },
  {
    id: 'is-hukukunda-calisma-haklari',
    title: 'İş Hukukunda Çalışma Hakları',
    date: '5 Ocak 2024',
    excerpt: 'Çalışanların temel hakları, iş sözleşmeleri ve işveren yükümlülükleri hakkında bilmeniz gerekenler.',
    category: 'İş Hukuku',
    image: 'https://readdy.ai/api/search-image?query=Professional%20workplace%20rights%20concept%20with%20business%20people%2C%20employment%20contract%20documents%2C%20modern%20corporate%20office%2C%20clean%20professional%20design%2C%20legal%20consultation%20atmosphere&width=400&height=250&seq=article3&orientation=landscape',
    slug: 'is-hukukunda-calisma-haklari'
  }
];

export default function BlogSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 font-poppins">
            Hukuki Görüşlerimiz ve Yayınlarımız
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto font-poppins font-light">
            Güncel hukuki gelişmeler ve uzman görüşlerimiz
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article, index) => (
            <article
              key={article.id}
              className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 group animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <Link to={`/articles/${article.slug}`} className="block">
                <div className="overflow-hidden rounded-t-lg">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-xs font-medium text-slate-900 bg-gray-100 px-2 py-1 rounded font-poppins">
                      {article.category}
                    </span>
                    <span className="text-xs text-slate-500 font-poppins font-light">{article.date}</span>
                  </div>

                  <h3 className="text-lg font-semibold text-slate-900 mb-3 leading-tight group-hover:text-slate-700 transition-colors font-poppins">
                    {article.title}
                  </h3>

                  <p className="text-sm text-slate-600 leading-relaxed mb-4 font-poppins font-light">{article.excerpt}</p>

                  <span className="text-sm font-medium text-slate-900 hover:text-slate-700 transition-colors group-hover:translate-x-1 transform duration-200 font-poppins whitespace-nowrap cursor-pointer">
                    Devamını Oku
                    <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center mt-10 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <Link 
            to="/articles"
            className="text-sm font-medium text-slate-900 hover:text-slate-700 transition-all duration-200 border border-slate-900 px-4 py-2 rounded hover:bg-slate-900 hover:text-white transform hover:scale-105 font-poppins whitespace-nowrap cursor-pointer inline-block"
          >
            Tüm Yayınları Görüntüle
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
